import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import UserAvatar from './UserAvatar';
import './StitchHeader.css';

function StitchHeader({ onNotifications, unreadCount = 0 }) {
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMenuClosing, setIsMenuClosing] = useState(false);
  const quickNavigation = [
    { label: 'خانه', icon: 'home', path: '/' },
    { label: 'ساخت آزمون', icon: 'add_circle', path: '/create' },
    { label: 'داشبورد من', icon: 'dashboard', path: '/dashboard' },
  ];

  const closeMenu = (afterClose) => {
    setIsMenuClosing(true);
    window.setTimeout(() => {
      setIsMenuOpen(false);
      setIsMenuClosing(false);
      afterClose?.();
    }, 220);
  };

  const goTo = (path) => {
    closeMenu(() => navigate(path));
  };

  const handleLogout = () => {
    closeMenu(logout);
  };

  return (
    <header className="stitch-app-header">
      <div className="stitch-app-header-content">
        <button className="stitch-app-brand" type="button" onClick={() => navigate('/')}>
          چقدر منو می‌شناسی؟
        </button>

        <div className="stitch-header-tools">
          <button
            className="stitch-menu-toggle"
            type="button"
            aria-label="باز کردن منو"
            aria-expanded={isMenuOpen}
            onClick={() => {
              setIsMenuClosing(false);
              setIsMenuOpen(true);
            }}
          >
            <span />
            <span />
            <span />
          </button>
          <button
            className="stitch-app-avatar"
            type="button"
            aria-label={isAuthenticated ? 'رفتن به داشبورد' : 'ورود به حساب'}
            onClick={() => navigate(isAuthenticated ? '/profile' : '/login')}
          >
            <UserAvatar user={user} />
          </button>
          {onNotifications && (
            <button className="stitch-notification-toggle" type="button" onClick={onNotifications} aria-label="اعلان‌ها">
              ●
              {unreadCount > 0 && <span>{unreadCount}</span>}
            </button>
          )}
        </div>
      </div>

      {isMenuOpen && (
        <div className={`stitch-menu-layer ${isMenuClosing ? 'is-closing' : ''}`} role="presentation" onClick={() => closeMenu()}>
          <aside className="stitch-drawer" role="dialog" aria-modal="true" aria-label="منوی اصلی" onClick={(event) => event.stopPropagation()}>
            <div className="stitch-drawer-topbar">
              <strong>منو</strong>
              <button type="button" aria-label="بستن منو" onClick={() => closeMenu()}>×</button>
            </div>
            <nav className="stitch-drawer-nav">
              {quickNavigation.map((item) => (
                <button key={item.path} type="button" onClick={() => goTo(item.path)}>
                  <span className="material-symbols-outlined stitch-nav-icon">{item.icon}</span>
                  {item.label}
                </button>
              ))}
              <button className="stitch-drawer-premium" type="button" onClick={() => goTo('/premium')}>
                <span className="material-symbols-outlined stitch-nav-icon">star</span>
                نسخه حرفه‌ای
              </button>
              {isAuthenticated && (
                <button type="button" onClick={() => goTo('/profile')}>
                  <span className="material-symbols-outlined stitch-nav-icon">person</span>
                  پروفایل من
                </button>
              )}
              {isAuthenticated ? (
                <button className="stitch-drawer-logout" type="button" onClick={handleLogout}>
                  <span className="material-symbols-outlined stitch-nav-icon">logout</span>
                  خروج
                </button>
              ) : (
                <button className="stitch-drawer-login" type="button" onClick={() => goTo('/login')}>
                  <span className="material-symbols-outlined stitch-nav-icon">login</span>
                  ورود / ثبت‌نام
                </button>
              )}
            </nav>
          </aside>
        </div>
      )}
      <nav className="stitch-mobile-nav" aria-label="دسترسی سریع">
        {quickNavigation.map((item) => (
          <button key={item.path} type="button" onClick={() => navigate(item.path)}>
            <span className="material-symbols-outlined stitch-nav-icon">{item.icon}</span>
            {item.label}
          </button>
        ))}
      </nav>
    </header>
  );
}

export default StitchHeader;
